<i18n locale="en">
{
  "label": "Max"
}
</i18n>
<template>
  <span class="upsell-gate-badge" data-testid="upsell-gate-badge">
    <SparkleFilled :size="12" />
    {{ text ?? t('label') }}
  </span>
</template>

<script lang="ts" setup>
import { SparkleFilled } from '@owner/icons-vue/SparkleFilled'
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    text?: string
  }>(),
  {
    text: undefined,
  }
)

const { t } = useI18n()
</script>

<style lang="scss" scoped>
// Compact gate badge for nav items and pickers. Max-plan purple from the
// tier-upgrades design — not yet in the Hermes token palette.
.upsell-gate-badge {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  color: #73429f;
  background-color: #efeaf3;
}
</style>
